// export const LOGIN_USER = "/admin/admin-login";
// export const VIEW_USER = "/users/session";
// export const UPDATE_ADMIN = "/users/update/";
export const LOGIN_CHECK = "/admin/login-check";
export const TWO_FA_SETUP = "/admin/2fa/setup";
export const TWO_FA_SETUP_VERIFY = "/admin/2fa/setup/verify";
export const LOGIN_USER = "/admin/login";
export const UPDATE_ADMIN = "/admin/update/";
export const VIEW_USER = "/admin/session";
export const DETAILS = "/admin/detail";
export const FORGET_PASSWORD = "/admin/forgotPassword";
export const VERIFY_OTP = "/admin/verifyOtp";
export const RESET_PASSWORD = "/admin/resetPassword";
export const USER_LOGOUT = "/admin/logout";
export const CHANGE_PASSWORD = "/admin/changePassword";

// File
export const POST_FILE = "/settings/uploadFile";
export const POST_REMOVE_FILE = "/settings/remove";

// statistics
export const GET_USER_STATISTICS = "/statistic/userStatistic";
export const GET_BTNC_STATISTICS = "/statistic/btncStatistic";
export const GET_ENERGY_STATISTICS = "/statistic/energyStatistic";
export const GET_CLAIM_STATISTICS = "/statistic/claimStatistic";
export const GET_TASK_STATISTICS = "/statistic/taskStatistic";

///Setting apis
export const GET_SETTINGS = "/settings/view";
export const GET_GAME_SETTINGS = "/settings/gameSetting";
export const UPDATE_SETTINGS = "/settings/update";
export const UPDATE_GAME_SETTING = "/settings/game/update";
export const UPDATE_ENERGY_SETTING = "/settings/energy/update";
export const UPDATE_LEADERBOARD_SETTING = "/settings/leaderboard/update";
export const UPDATE_MAINTENANCE_SETTING = "/settings/maintenance/update";
export const UPDATE_HISTORICAL_DATA_SETTING = "/settings/historicalData/update";
export const UPDATE_WELCOME_BONUS_SETTING = "/settings/welcome/update";
export const UPDATE_CRYPTO_EXCHANGE_SETTING = "/settings/exchange/update";
export const UPDATE_CRYPTO_DEPOSIT_SETTING = "/settings/deposit/update";
export const UPDATE_CRYPTO_CONVERSION_SETTING = "/settings/external/update";
export const UPDATE_PROMOTION_SETTING = "/settings/promotion/update";
export const UPDATE_PAYMENT_SETTINGS = "/settings/payment/update";
export const UPDATE_BUYENERGY_SETTINGS = "/settings/buyEnergy/update";
export const UPDATE_REWARD_SETTINGS = "/settings/rewards/update";
export const UPDATE_JACKPOT_SETTINGS = "/settings/jackpot/update";
export const GET_BOMB_LINE_COUNT = "/settings/bombLineCount";

export const WEEKLY_REWARD_HISTORY = "/settings/reward/history";
export const UPDATE_WEEKLY_REWARD = "/settings/reward/history/";
export const RECALCULATE_WEEKLY_REWARD = "/settings/recalculate/rewards";

export const GET_EXPORT_REQUEST_LIST = "/settings/exportRequest";

export const GET_COIN_HISTORY_LIST = "/settings/coinhistory";

// coin List
export const GET_COIN_LIST = "/settings/coinsListing";
export const RELOAD_COIN_LIST = "/settings/reloadCoinsList";

//// user
export const GET_USERS = "/users/list";
export const GET_SUBADMIN_USERS = "/users/subAdmin/list";
export const USER_DETAILS = "/users/user-detail/";
export const ADD_USER = "/users/add";
export const UPDATE_USER = "/users/";
export const GET_USER_DETAILS = "/users";
export const UPDATE_USER_STATUS = "/users/block/unblock/";
export const REWARD_LEADERBOARD = "/users/reward/leaderboard";

//levels
export const GET_LEVELS = "/level/list";
export const ADD_LEVEL = "/level/create";
export const UPDATE_LEVEL = "/level/edit";

//Roadmaps
export const GET_ROADMAP_LIST = "/roadmaps/list";
export const ADD_ROADMAP = "/roadmaps/add";
export const EDIT_ROADMAP = "/roadmaps/";
export const DELETE_ROADMAP = "/roadmaps/";
export const SORT_ROADMAPS = "/roadmaps/sorting";

// Historical Data
export const GET_MONGOSQL_SETTING = "/settings/mongotoMysql";
export const GET_MONGOSQL_SETTING_DETAILS = "/settings/mongotoMysql";
export const GET_REMOVE_FROM_MONGO = "/settings/removefromMongo";
export const GET_REMOVE_FROM_MONGO_DETAILS = "/settings/removefromMongo";
export const DELETE_MONGOSQL_SETTING = "/settings//removeDatafromMongo";

//Energy packages
export const GET_ENERGY_PACKAGE_LIST = "/energy/package/list";
export const ADD_ENERGY_PACKAGE = "/energy/package/add";
export const EDIT_ENERGY_PACKAGE = "/energy/package/";
export const DELETE_ENERGY_PACKAGE = "/energy/package/";
export const GET_ENERGY_PURHCASE_HISTORY = "/energy/package/history";
export const GET_ENERGY_PURHCASE_HISTORY_DETAILS =
  "/energy/package/history/details";

//Round Multiplier
export const GET_ROUND_MULTIPLIER_LIST = "/roundMultiplier/list";
export const ADD_ROUND_MULTIPLIER = "/roundMultiplier/add";
export const EDIT_ROUND_MULTIPLIER = "/roundMultiplier/update/";
export const DELETE_ROUND_MULTIPLIER = "/roundMultiplier/remove/";
export const ROUND_MULTIPLIER_STATUS_CHANGE = "/roundMultiplier/statusChange/";
export const GET_ROUND_MULTIPLIER_DETAILS = "/roundMultiplier/details";
export const GET_USER_ROUND_MULTIPLIER_LIST = "/roundMultiplier/user/list";
export const GET_USER_ROUND_MULTIPLIER_DETAILS =
  "/roundMultiplier/userRoundMultiplier";

//System Announcement
export const GET_SYSTEM_ANNOUNCEMENT_LIST = "/settings/systemAnnouncement/get";
export const GET_SYSTEM_ANNOUNCEMENT_DETAILS = "/settings/systemAnnouncement/get";
export const ADD_SYSTEM_ANNOUNCEMENT = "/settings/systemAnnouncement/add";
export const CANCEL_SYSTEM_ANNOUNCEMENT = "/settings/systemAnnouncement/cancel";
export const CANCEL_SCHEDULED_TIME_SYSTEM_ANNOUNCEMENT = "/settings/systemAnnouncement/scheduledTime/cancel";


// pages
export const GET_PAGE_LIST = "/admin/pages/list";
export const ADD_PAGE = "/admin/pages/add";
export const EDIT_PAGE = "/admin/pages/";
export const DELETE_PAGE = "/admin/pages/";

//language
export const GET_LANGUAGE_LIST = "/settings/language/list";
export const ADD_LANGUAGE = "/settings/language/add";
export const EDIT_LANGUAGE = "/settings/language/";
export const DELETE_LANGUAGE = "/settings/language/";
export const GET_LANGUAGE_CODES = "/settings/language/codes";
export const GET_LANGUAGE_JSON = "/settings/language/json/";
export const UPDATE_LANGUAGE_KEY = "/settings/language/key";

//badges
export const GET_BADGE_LIST = "/admin/badge/list";
export const ADD_BADGE = "/admin/badge/add";
export const EDIT_BADGE = "/admin/badge/";
export const DELETE_BADGE = "/admin/badge/";

//avatar
export const GET_AVATAR_LIST = "/avatar/list";
export const ADD_AVATAR = "/avatar/add";
export const EDIT_AVATAR = "/avatar/";
export const DELETE_AVATAR = "/avatar/";

//avatar category
export const GET_AVATAR_CATEGORY_LIST = "/avatar/category/list";
export const ADD_AVATAR_CATEGORY = "/avatar/category/add";
export const EDIT_AVATAR_CATEGORY = "/avatar/category/";
export const DELETE_AVATAR_CATEGORY = "/avatar/category/";

//avatar characterstic
export const GET_AVATAR_CHARACTERSTIC_LIST = "/avatar/characterstic/list";
export const ADD_AVATAR_CHARACTERSTIC = "/avatar/characterstic/add";
export const EDIT_AVATAR_CHARACTERSTIC = "/avatar/characterstic/";
export const DELETE_AVATAR_CHARACTERSTIC = "/avatar/characterstic/";

export const GET_CSRF_TOKEN = "/users/token";

//game
// export const GAME_HISTORY_LIST = "/games/history-list";
export const GAME_HISTORY_LIST = "/games/history-admin";
export const GAME_HISTORY_DETAILS = "/games/details";
export const GAME_LEADERBOARD_LIST = "/leaderboard/list";
export const UPDATE_LEADERBOARD = "/leaderboard/";
export const CLAIM_HISTORY_LIST = "/claim/adminList";
export const ENERGY_HISTORY_LIST = "/energy/list";
export const LEADERBOARD_TRANSACTION = "/leaderboard/transactionList";
export const EXPORT_GAME_LEADERBOARD = "/leaderboard/export/list";

//logout
// export const USER_LOGOUT = "/users/logout";
// export const CHANGE_PASSWORD = "/users/admin/password";

//task
export const TASK_LIST = "/tasks/list";
export const ADD_TASK = "/tasks/add";
export const UPDATE_DELETE_TASK = "/tasks/";
export const COINS_LIST = "/settings/coinsList";
export const AUTO_REFILL = "/settings/autoRefillCoin";
export const EXPORT_USERS_LIST = "/users/export/list";
export const EXPORT_GAME_LIST = "/games/export/list";
export const EXPORT_CLAIM_LIST = "/claim/export/list";

//logs
export const LOGS_LIST = "/users/logs/list";

//balance
export const UPDATE_USER_BALANCE = "/users/balance/";
export const UPDATE_COIN_BALANCE = "/users/updateCoinBalance";
export const WALLET_BALANCE_LIST = "/users/balanceList";
export const BALANCE_HISTORY_TRANSACTION = "/users/coinHistoryTransaction";
export const GET_COIN_BALANCE = "/users/getBalance";

//game
export const GAME_END_BY_ADMIN = "/games/end/";

//statistics
export const GET_STATISTICS_EXCELL_FILE = "/statistics/excel";
export const GET_STATISTICS_GRAPH = "/statistics/graph";
export const GET_STATISTICS_COUNT = "/statistics/counts";
export const REMAINING_CRYPTO = "/statistics/remain/crypto";
export const GET_STATISTICS_LINE_COUNT = "/statistics/line/count";
export const GET_STATISTICS_DATA = "/statistics/getStatisticsData";
export const EXPORT_STATS = "/statistics/exportStats";

//subadmins:-
export const ADD_SUB_ADMIN = "/users/admin-register";

export const DELETE_USER = "/users/delete";

export const BTNC_HISTORY_LIST = "/btnc/history";

export const USER_TASKS_LIST = "/tasks/completed/list";
export const USER_REFFERALS_LIST = "/referrals/list";
export const USER_EARNINGS_LIST = "/referrals/history";
export const USER_IP_LIST = "/users/ipHistory/list";

//jackpot
// export const JACKPOT_HISTORY_LIST = "/jackpot/history/list";
export const JACKPOT_HISTORY_LIST = "/jackpot/history/admin";
export const JACKPOT_HISTORY_DETAILS = "/jackpot/details";
export const EXPORT_JACKPOT_HISTORY = "/jackpot/export/list";


// Permission
export const GET_ROLE_LIST = "/permission/role/list";
export const ADD_ROLE = "/permission/role/add";
export const EDIT_ROLE = "/permission/role/update/";
export const STATUS_ROLE = "/permission/role/status/";
export const DETAILS_ROLE = "/permission/role/details/";
export const DELETE_ROLE = "/permission/role/delete/";
export const GET_ACTIVE_PERMISSION_LIST = "/permission/getPermissionList";

export const GET_PERMISSION_LIST = "/permission/permissionList";
export const ADD_PERMISSION = "/permission/addPermission";
export const EDIT_PERMISSION = "/permission/updatePermission/";
export const DELETE_PERMISSION = "/permission/deletePermission/";

export const GET_PERMISSION_META = "/permission/list";
export const ADD_PERMISSION_META = "/permission/add";
export const EDIT_PERMISSION_META = "/permission/update/";
export const DELETE_PERMISSION_META = "/permission/delete/";
export const DETAILS_PERMISSION_META = "/permission/details/";
export const GET_ACTIVE_PERMISSION_META = "/permission/active";



export const GET_ADMIN = "/admin/list";
export const ADD_ADMIN = "/admin/add";
export const EDIT_ADMIN = "/admin/update/";
export const DELETE_ADMIN = "/admin/delete/";
export const DETAILS_ADMIN = "/admin/details/";
export const STATUS_CHANGE_ADMIN = "/admin/statusChange/";
export const ROLE_ACTIVE_LIST = "/admin/activeRole";



